import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/stored/page', Object.assign({}, options, { params }));

export const getrRchargeList = (params, options) =>
  request.get('/api/v4ward/car/recharge/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/vehicle/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/stored/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/v4ward/car/stored/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/stored/update', params, options);

export const saveCarCharge = (params, options) =>
  request.post('/api/v4ward/car/stored/carStoredRecharge', params, options);

export const carNoChange = (params, options) => request.post('/api/v4ward/car/stored/carNoChange', params, options);

export const checkCarIsExist = (params, options) =>
  request.get('/api/v4ward/car/stored/checkCarIsExist', Object.assign({}, options, { params }));